import React, { useCallback, FocusEvent, useState, useEffect, useRef } from "react";
import {
  retornoAutoComplete,
  AutocompleteSaurus,
} from "../autocomplete-saurus/autocomplete-saurus";
import { useGetPessoaById } from "data/api/gestao/pessoa";
import { PessoasModel } from "model/api/gestao/pessoa/pessoas-model";
import { EnumTipoPessoas } from "model/enums/enum-tipo-pessoas";
import { isEmpty } from "lodash";
import { useGetPessoaTipo } from "data/api/gestao/pessoa/get-pessoa-tipo";

export interface AutocompleteVendedorProps {
  label?: string;
  loadingExterno?: boolean;
  name?: string;
  value?: string;
  defaultValue?: string;
  defaultName?: string;
  error?: boolean;
  helperText?: string | undefined;
  placeholder?: string;
  allowSubmit?: boolean;
  disabled?: boolean;
  onBlur?: (event: FocusEvent<HTMLInputElement>) => any;
  onChange?: (value: retornoAutoComplete) => any;
  fullWidth?: boolean;
  size?: 'small' | 'medium';
  fetchOnLoad?: boolean;
  query?: string;
  focus?: boolean;
  onClick?: (e?: any) => any;
  revendedorId?: string
}

export const AutocompleteVendedor = ({
  onChange,
  loadingExterno,
  fullWidth,
  revendedorId,
  ...props
}: AutocompleteVendedorProps) => {
  const [vendedorState, setVendedorState] = useState<Array<PessoasModel>>(
    new Array<PessoasModel>()
  );
  const { getPessoaTipo, carregando: carregandoPessoas } = useGetPessoaTipo()
  const { getPessoaById, carregando: carregandoPessoa } = useGetPessoaById()

  const [nomeValor, setNomeValor] = useState<string>('')

  const allowFetch = useRef<boolean>(true)

  const getVendedorById = useCallback(async (id: string) => {
    try {
      const res = await getPessoaById(id)

      if (res.erro) throw res.erro

      if (!res.resultado) return
      allowFetch.current = false
      setVendedorState([res.resultado.data])
    } catch (e: any) {

    }
  }, [getPessoaById])

  const getFuncionariosRevendaWrapper = useCallback(async (termo: string) => {
    try {

      const ret = await getPessoaTipo(1, `pageSize=100&tiposPessoas=${EnumTipoPessoas.Representante}${termo.length > 0 ? `query=${termo}` : ''}`);
      if (ret.erro) throw ret.erro;
      let revendas: Array<PessoasModel> = new Array<PessoasModel>();
      if (!ret.resultado) return
      const resultado = ret.resultado?.data?.list as Array<PessoasModel>

      if (ret.resultado?.data?.list?.length > 0) {

        revendas = resultado.filter(x => !isEmpty(x.revendaId));

        if (revendedorId && !isEmpty(revendedorId)) {
          revendas = resultado.filter(x => x.revendaId === revendedorId)
        }
      }

      setVendedorState(revendas)
    } catch (e: any) { }
  }, [getPessoaTipo, revendedorId]);

  const onChangeWrapper = useCallback(
    (value: retornoAutoComplete) => {
      if (onChange) onChange(value);
    },
    [onChange]
  );

  const carregando = carregandoPessoas || carregandoPessoa || loadingExterno

  const onPesquisa = useCallback(
    async (termo: string) => {
      await getFuncionariosRevendaWrapper(termo);
    },
    [getFuncionariosRevendaWrapper]
  );

  useEffect(() => {
    if(!isEmpty(props.defaultValue) && !isEmpty(props.defaultName)){
      setVendedorState([new PessoasModel(props.defaultValue, EnumTipoPessoas.Funcionario, props.defaultName)])
      setNomeValor(props.defaultName!)
      return
    }
    if (!isEmpty(props.defaultValue) && props.fetchOnLoad) {
      getVendedorById(props.defaultValue!)
    }

    if(props.fetchOnLoad){
      onPesquisa('')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.defaultValue])


  useEffect(() => {
    if (props.value) {
      const valor = vendedorState.find(item =>
        item.id === props.value
      )
      setNomeValor(valor?.nomeComercial ?? '')
      return
    }
    setNomeValor('')
  }, [props, props.fetchOnLoad, props.value, vendedorState])


  return (
    <AutocompleteSaurus
      disabled={props.disabled}
      name={props.name}
      loading={carregando}
      onChange={onChangeWrapper}
      onPesquisa={onPesquisa}
      onClick={props.onClick}
      opcoes={vendedorState}
      optionLabelKey="nomeComercial"
      optionValueKey="nomeComercial"
      onBlur={props.onBlur}
      noOptionsText="Vendedor não localizado."
      value={nomeValor}
      allowSubmit={props.allowSubmit}
      label={props.label}
      helperText={props.helperText}
      error={props.error}
      placeholder={props.placeholder}
      fullWidth={fullWidth}
      size={props.size}
      focus={props.focus}
    />
  );
};
